<script setup lang="ts">
const store = usePortfolioStore()
const featured = computed(() => store.projects[0])
const itemBgs = [
  'linear-gradient(180deg,#f5e9ff 0%,#eadcff 100%)',
  'linear-gradient(180deg,#ffe8ee 0%,#ffd9e4 100%)',
  'linear-gradient(180deg,#fff2cf 0%,#ffe6ad 100%)',
  'linear-gradient(180deg,#e6f0ff 0%,#d8e6fb 100%)'
]
</script>

<template>
  <div class="grid gap-4 lg:grid-cols-2">
    <section id="projects" data-reveal class="rounded-[26px] p-5 shadow-[var(--t-clay)] [background:var(--t-sect4)]">
      <div class="flex items-center justify-between gap-2.5">
        <h2 class="text-base font-extrabold text-[var(--t-h14)]">پروژه‌های اخیر</h2>
        <span class="rounded-full bg-white/80 px-3 py-1 text-[11px] font-bold text-[var(--t-badge4)]
                     shadow-[inset_0_2px_3px_rgb(255_255_255/0.9),0_3px_8px_rgb(190_70_120/0.12)]">{{ store.projects.length }} پروژه</span>
      </div>
      <ul class="mt-3.5 grid gap-2.5">
        <li v-for="(pr, i) in store.projects.slice(0, 4)" :key="pr.id ?? pr.slug">
          <NuxtLink :to="'/projects/' + (pr.slug || pr.id)"
                    class="flex w-full items-center gap-3 rounded-[20px] p-2.5 text-right
                           shadow-[inset_0_2px_3px_rgb(255_255_255/0.96),0_6px_12px_rgb(190_70_120/0.10)] transition duration-300
                           hover:-translate-y-0.5 hover:shadow-[var(--t-clay)]"
                    :style="{ background: itemBgs[i % itemBgs.length] }">
            <img v-if="pr.media" :src="pr.media.url" :alt="pr.title" class="h-[52px] w-[52px] shrink-0 rounded-[14px] object-cover" />
            <span v-else class="h-[52px] w-[52px] shrink-0 rounded-[14px] bg-[var(--t-panel4)]" />
            <span class="grid min-w-0 flex-1 gap-0.5">
              <span class="truncate text-[13px] font-extrabold text-[var(--t-h14)]">{{ pr.title }}</span>
              <span class="truncate text-[11.5px] text-[var(--t-soft4)]">{{ pr.summary }}</span>
            </span>
            <span class="grid h-[34px] w-[34px] shrink-0 place-content-center rounded-full text-white shadow-[var(--t-clay-btn)] [background:var(--t-grad-btn)]">
              <svg viewBox="0 0 24 24" class="h-3.5 w-3.5 -scale-x-100" fill="currentColor"><path d="M8 5l10 7-10 7z" /></svg>
            </span>
          </NuxtLink>
        </li>
      </ul>
    </section>

    <section v-if="featured" data-reveal class="flex flex-col rounded-[26px] p-5 shadow-[var(--t-clay)] [background:var(--t-sect4)]">
      <div class="flex items-center justify-between gap-2.5">
        <h2 class="text-base font-extrabold text-[var(--t-h14)]">پروژه‌ی منتخب</h2>
        <NuxtLink :to="'/projects/' + (featured.slug || featured.id)"
                  class="rounded-full bg-white/80 px-3 py-1 text-[11px] font-bold text-[var(--t-badge4)]
                         shadow-[inset_0_2px_3px_rgb(255_255_255/0.9),0_3px_8px_rgb(190_70_120/0.12)]">مشاهده</NuxtLink>
      </div>
      <NuxtLink :to="'/projects/' + (featured.slug || featured.id)"
                class="relative mt-3.5 min-h-[210px] flex-1 overflow-hidden rounded-[22px] shadow-[var(--t-clay)]">
        <img v-if="featured.media" :src="featured.media.url" :alt="featured.title" class="absolute inset-0 h-full w-full object-cover" />
        <span class="absolute inset-x-0 bottom-0 flex items-end justify-between gap-2.5 bg-gradient-to-t
                     from-[#3a2864d9] to-transparent p-3.5 pt-10">
          <span class="grid gap-0.5 text-right">
            <span class="text-[15px] font-extrabold text-white">{{ featured.title }}</span>
            <span class="text-[11.5px] text-white/80">{{ featured.tags.join(' · ') }}<template v-if="featured.year"> · {{ featured.year }}</template></span>
          </span>
          <span class="grid h-9 w-9 shrink-0 place-content-center rounded-full text-white shadow-[var(--t-clay-btn-pink)] [background:var(--t-grad-btn-pink)]">
            <svg viewBox="0 0 24 24" class="h-3.5 w-3.5 -scale-x-100" fill="currentColor"><path d="M8 5l10 7-10 7z" /></svg>
          </span>
        </span>
      </NuxtLink>
    </section>
  </div>
</template>
